import { Box, Button, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getMockWeek, notifyGrowChanged } from "../hooks/useGrowCommunity";
import { CARD_BORDER, SOFT_BG, TEXT_SUB, g } from "../styles";

// ⚠️ FE-first review aid — lets reviewers flip between the mock weeks, "all
// situations" and the setup-incomplete state. Remove at graduation.
const s = {
  bar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    backgroundColor: SOFT_BG,
    border: CARD_BORDER,
    borderRadius: "12px",
    padding: "8px 12px",
  },
  label: { fontSize: "13px", fontWeight: 500, color: TEXT_SUB },
};

const WEEKS = [
  { value: "1", key: "week1" },
  { value: "2", key: "week2" },
  { value: "all", key: "all" },
];

const PreviewSwitcher = () => {
  const { t } = useTranslation("page-grow-community");
  const [searchParams, setSearchParams] = useSearchParams();
  const week = getMockWeek();
  const setupIncomplete = searchParams.get("setup") === "1";

  // Switch in place — no reload. The URL holds the choice (shareable): the
  // grow hooks re-read the week on the change event, and the Grow page reads
  // `setup` for its own setup card only — the sidebar keeps the real data.
  const go = (changes) => {
    const next = new URLSearchParams(searchParams);
    Object.entries(changes).forEach(([key, value]) => (value == null ? next.delete(key) : next.set(key, value)));
    setSearchParams(next, { replace: true });
  };
  const pickWeek = (value) => {
    go({ week: value });
    notifyGrowChanged();
  };
  const toggleSetup = () => {
    go({ setup: setupIncomplete ? null : "1" });
  };

  return (
    <Box sx={s.bar}>
      <Typography component="span" sx={s.label}>{t("preview.label")}</Typography>
      {WEEKS.map((option) => (
        <Button
          key={option.value}
          variant="outlined"
          size="small"
          onClick={() => pickWeek(option.value)}
          aria-pressed={week === option.value}
          sx={g.toggleChip(week === option.value)}
        >
          {t(`preview.${option.key}`)}
        </Button>
      ))}
      <Button
        variant="outlined"
        size="small"
        onClick={toggleSetup}
        aria-pressed={setupIncomplete}
        sx={g.toggleChip(setupIncomplete)}
      >
        {t("preview.setup")}
      </Button>
    </Box>
  );
};

export default PreviewSwitcher;
